import { IAuthenticationStore } from "src/stores/authenticationStore.d";
import AuthenticationApi from "src/api/authenticationApi";
import { IAuthentication } from "src/models/authentication";
import { toJS } from "mobx";

export class AuthenticationStore implements IAuthenticationStore {
  authModel: IAuthentication;

  async getJWT(clientId: string, authCode: string) {
    let isLoading = false;
    try {
      isLoading = true;
      const request = {
        clientId,
        grantType: "authorization_code",
        code: authCode,
      };
      const res = await AuthenticationApi.login(request);
      const authJS = this.getAuthenticationJs();
      authJS.jwtAuthToken = res;
    } catch (error) {
      console.log("========= error: ", error);
    } finally {
      isLoading = false;
    }
  }

  getAuthenticationJs() {
    return toJS(this.authModel);
  }
  setAuthentication(auth?: IAuthentication) {
    this.authModel = auth;
  }
}

export default new AuthenticationStore();
